export default __webpack_public_path__ + "static/media/report11.1dcd1dfe.png";